export default __webpack_public_path__ + "static/logo-5317a250ad0d0639751511567f2b2aef.svg";